import { render, staticRenderFns } from "./resourceUser.vue?vue&type=template&id=253e874e&scoped=true"
import script from "./resourceUser.vue?vue&type=script&lang=js"
export * from "./resourceUser.vue?vue&type=script&lang=js"
import style0 from "./resourceUser.vue?vue&type=style&index=0&id=253e874e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253e874e",
  null
  
)

export default component.exports